import React from 'react';
import { Table, Button, Icon } from 'rbx';
import styled from 'styled-components';
import moment from 'moment';
import { first } from 'lodash';
import ReactTooltip from 'react-tooltip';

const Element = styled.div`
  width: 8rem;
`;

const List = ({ fees, users = [], onEdit, onDelete }) => (
  <>
    {fees.map(item => {
      const updatedBy = item.audit && item.audit.updated_by;
      const userMatch = users.filter(u => u.user_id === updatedBy);
      const user = userMatch.length !== 0 ? first(userMatch) : undefined;

      return (
      <Table.Row key={item.fee_id}>
        <Table.Cell>
          <Element>{item.service_type_name}</Element>
        </Table.Cell>
        <Table.Cell>{item.name}</Table.Cell>
        <Table.Cell>{item.display}</Table.Cell>
        <Table.Cell>
          <Element>{item.sale_method}</Element>
        </Table.Cell>
        <Table.Cell>
          <Element>{item.type}</Element>
        </Table.Cell>
        <Table.Cell>
          {item.type !== 'PERCENTAGE' ? `$` : ''}
          {parseFloat(item.value).toFixed(2)}
        </Table.Cell>
        <Table.Cell>
          {item.min_fee != null ? `$${parseFloat(item.min_fee).toFixed(2)}` : '-'}
        </Table.Cell>
        <Table.Cell>
          {item.max_fee != null ? `$${parseFloat(item.max_fee).toFixed(2)}` : '-'}
        </Table.Cell>
        <Table.Cell>{item.tax}</Table.Cell>
        <Table.Cell>{parseFloat(item.taxValue).toFixed(2)}%</Table.Cell>
        <Table.Cell>
          {item.is_payment_gateway_fee === true ? 'Yes' : 'No'}
        </Table.Cell>
        <Table.Cell>
          {item.is_kravein_charge === true ? 'Yes' : 'No'}
        </Table.Cell>
        <Table.Cell>
          <Element>{item.applies_to}</Element>
        </Table.Cell>
        <Table.Cell>
          {user ? (
            <React.Fragment>
              <p data-tip={user.full_name}>{user.full_name}</p>
              <ReactTooltip place="top" type="dark" effect="float">
                <span>
                  <p>email: {user.email}</p>
                  <p>objectId: {user.user_id}</p>
                </span>
              </ReactTooltip>
            </React.Fragment>
          ) : (
            updatedBy
          )}
        </Table.Cell>
        <Table.Cell>
          {item.audit && item.audit.updated_at
            ? moment(item.audit.updated_at).format('lll')
            : '-'}
        </Table.Cell>
        <Table.Cell>
          <Element>
            <Button.Group hasAddons>
              <Button onClick={() => onEdit(item)}>
                <Icon size="small">
                  <i className="fas fa-edit" />
                </Icon>
              </Button>
              <Button onClick={() => onDelete(item)}>
                <Icon size="small">
                  <i className="fas fa-trash has-text-grey" />
                </Icon>
              </Button>
            </Button.Group>
          </Element>
        </Table.Cell>
      </Table.Row>
      );
    })}
  </>
);

export default List;
